import React, { Component } from 'react';
import ReactDom from 'react-dom';
import axios from 'axios';
import { Provider } from 'react-redux';
import store from './store';

import InformalUpdateRow from './components/opinions-informal-update-row';

export default class InformalUpdate extends Component {
	render() {
		return (
			<Provider store={ store }>
				<div><InformalUpdateRow /></div>
			</Provider>
		);
	}
}

var InformalUpdateElement = document.getElementById( 'informal-update-jurisdictions' );
if ( InformalUpdateElement ) {
	ReactDom.render( <InformalUpdate />, InformalUpdateElement );
}
